const COLOR_WHITELIST = /^#[0-9a-fA-F]{3,8}$/

export const sanitizeColor = (color: string): string => (COLOR_WHITELIST.test(color) ? color : '')
